/**
 * @flow
 * @relayHash a5b621c3c4b5ccbf8591a94ce91a6574
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCategoryTemplateMutationVariables = {|
  id: string
|};
export type DeleteCategoryTemplateMutationResponse = {|
  +deleteCategoryTemplate: {|
    +id: string
  |}
|};
export type DeleteCategoryTemplateMutation = {|
  variables: DeleteCategoryTemplateMutationVariables,
  response: DeleteCategoryTemplateMutationResponse,
|};
*/


/*
mutation DeleteCategoryTemplateMutation(
  $id: String!
) {
  deleteCategoryTemplate(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCategoryTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CategoryTemplateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCategoryTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCategoryTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCategoryTemplateMutation",
    "id": null,
    "text": "mutation DeleteCategoryTemplateMutation(\n  $id: String!\n) {\n  deleteCategoryTemplate(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bbf107ad80078432f509c36be2d179e3';
module.exports = node;
